import { useNotification } from '@revenuewell/logic-notification';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus/use-event-bus';
import { useEffect } from 'react';

export const EventBusNotificationMessageListener = () => {
  const { showError, showSuccess, showMessage } = useNotification();
  const { listen, unlisten } = useEventBus();

  const handleShowNotification = (event: any) => {
    const { message, type } = event.data as { message: string; type: 'success' | 'error' };

    if (type === 'success') {
      showSuccess(message);
    } else if (type === 'error') {
      showError(message);
    } else {
      showMessage(message);
    }
  };

  useEffect(() => {
    const notificationListener = listen('show-notification', handleShowNotification);

    return () => unlisten('show-notification', notificationListener);
  }, []);

  return null;
};
